import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Label from './Label';
import Classes from '../Classes';

const defaultLocale = 'en-GB';

const FeatureLabels = ({
  featureFilters
}) => (
  <div data-testid="Feature-Labels" className={classnames(Classes.featureLabelList)}>
    {
      featureFilters.map((filter) => ({
        name: filter.multilingualNames.find((lingual) => lingual.locale === defaultLocale)
          ? filter.multilingualNames.find((x) => x.locale === 'en-GB').name : null,
        colourCode: filter.colourCode
      }))

        .filter((filter) => filter.name !== undefined)
        .map((filter) => (<Label key={filter.name} value={filter.name} borderColour={filter.colourCode} />))
    }
  </div>
);

FeatureLabels.propTypes = {
  featureFilters: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default FeatureLabels;
